<template>
  <section class="high-efficiency-breeno">
    <div class="high-efficiency-breeno-sticky">
      <div ref="topText" v-textMotion="vm.isMobile ? 100 : 300" class="breeno-text-top-intro text-intro">
        <p class="title">Breeno 识屏</p>
        <p class="sub-title">长按一下，<br />你想要的都能知道</p>
        <p class="description">
          Breeno识屏更强大了，调出侧边栏随手一“叮”，就能在当前产品页比价同款商品、查看历史价格。刷短视频时听到好歌，简单“叮”一下，也能立刻识别歌曲。
        </p>
      </div>
      <div
        v-if="!vm.isMobile"
        ref="breenoIconContainer"
        class="breeno-icon-container wow"
        data-wow-duration=".7s"
        data-wow-delay="1s"
        :data-wow-offset="300"
        :class="pcBreenoEnter ? '' : 'textInPartMotion'"
        :style="breenoIconStyle"
      >
        <img
          ref="breenoIcon"
          v-lazy="require(`../../assets/zh/highEfficiency/breeno-icon.png`)"
          :data-webp="require(`../../assets/zh/highEfficiency/breeno-icon.webp`)"
          class="breeno-icon"
          :class="pcProgress < 0.5 ? '' : 'breeno-icon-hidden'"
          alt="ColorOS 11"
        />
        <img
          ref="breenoIcon"
          v-lazy="require(`../../assets/zh/highEfficiency/breeno-icon-rotate.png`)"
          class="breeno-icon"
          :class="
            pcProgress >= 0.75 ? 'breeno-icon-hide' : pcProgress >= 0.5 ? 'breeno-icon-rotate' : 'breeno-icon-hidden'
          "
          alt="ColorOS 11"
        />
      </div>
      <figure
        ref="breenoFigure"
        class="breeno-top-figure wow"
        :style="topFigureStyle"
        :class="vm.isMobile ? 'textInPartMotion' : ''"
        data-wow-duration="1s"
        data-wow-delay="0.3s"
        :data-wow-offset="100"
      >
        <img
          v-if="!vm.isMobile"
          v-lazy="require('../../assets/zh/highEfficiency/breeno-phone-1.png')"
          class="breeno-phone-img"
          alt="ColorOS 11"
        />
        <ul
          v-if="!vm.isMobile"
          class="breeno-icon-list"
          :class="
            pcProgress >= 0.75 ? 'breeno-icon-list__active' : pcProgress >= 0.5 ? 'breeno-icon-list__pending' : ''
          "
        >
          <li class="breeno-icon-item"></li>
          <li class="breeno-icon-item">
            <img v-lazy="require('../../assets/zh/highEfficiency/breeno-icon-item-1.png')" alt="ColorOS 11" />
            <div class="breeno-icon-item-text">
              <div class="breeno-icon-item-text__title">优惠券</div>
              <div class="breeno-icon-item-text__description">立减 200元</div>
            </div>
          </li>
          <li class="breeno-icon-item">
            <img v-lazy="require('../../assets/zh/highEfficiency/breeno-icon-item-2.png')" alt="ColorOS 11" />
            <div class="breeno-icon-item-text">
              <div class="breeno-icon-item-text__title">历史价格</div>
              <div class="breeno-icon-item-text__description">最低 5999 元</div>
            </div>
          </li>
          <li class="breeno-icon-item">
            <img v-lazy="require('../../assets/zh/highEfficiency/breeno-icon-item-3.png')" alt="ColorOS 11" />
            <div class="breeno-icon-item-text">
              <div class="breeno-icon-item-text__title">同款比价</div>
              <div class="breeno-icon-item-text__description">为你找到最低价格</div>
            </div>
          </li>
          <li class="breeno-icon-item">
            <img v-lazy="require('../../assets/zh/highEfficiency/breeno-icon-item-4.png')" alt="ColorOS 11" />
            <div class="breeno-icon-item-text">
              <div class="breeno-icon-item-text__title">加入自由收藏</div>
              <div class="breeno-icon-item-text__description">OPPO Find X2 P...</div>
            </div>
          </li>
        </ul>
        <img
          v-if="vm.isMobile"
          v-textMotion
          v-lazy="require('../../assets/zh/highEfficiency/breeno-phone-15.png')"
          class="breeno-phone-img"
          alt="ColorOS 11"
        />
        <img
          class="breeno-phone-img"
          src="../../assets/zh/highEfficiency/breeno-phone-2.png"
          alt="ColorOS 11"
          :style="`opacity: ${mobileSwitch ? 1 : 0}`"
        />
      </figure>
      <!-- <figure
        class="breeno-bottom-figure wow"
        :class="vm.isMobile ? 'textInPartMotion' : ''"
        data-wow-duration="1s"
        data-wow-delay="0.3s"
        :data-wow-offset="100"
      >
        <img
          v-if="vm.isMobile"
          v-textMotion
          v-lazy="require('../../assets/zh/highEfficiency/breeno-phone-1.png')"
          class="breeno-phone-img"
          alt="ColorOS 11"
        />
        <img
          class="breeno-phone-img"
          src="../../assets/zh/highEfficiency/breeno-phone-2.png"
          alt="ColorOS 11"
          :style="vm.isMobile ? `opacity: ${mobileSwitch ? 1 : 0}` : ''"
        />
      </figure> -->
      <div v-textMotion="100" class="breeno-text-bottom-intro text-intro">
        <p class="title">Breeno 指令</p>
        <p class="sub-title">
          复杂操作，一次到位
        </p>
        <p class="description">
          “钉钉打卡”、“打车回家”、“睡前设定”等十几个新指令，帮你从一连串的操作中解放出来，一步就能到位。同时你还可以把重复的事情自动化，新增了“到家打开wifi”、“到公司打开静音并提醒打卡”等近二十个自动指令，生活更高效。
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

export default {
  inject: ['vm'],
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      pcProgress: 0,
      pcBreenoEnter: false,
      pcInitFigureTransformY: 0,
      breenoPhoneFirstSwipeDistance: 0,
      breenoPhoneSecondSwipeDistance: 0,
      locationName: '',
      mobileSwitch: false
    };
  },
  computed: {
    breenoIconStyle() {
      const pcProgress = this.pcProgress > 0.5 ? 0.5 : this.pcProgress;
      return {
        transform: `translate3d(${(172 * pcProgress) / 0.5}px, ${(12 * pcProgress) / 0.5}px, 0) scale(${1 -
          ((1 - 0.1272) / 0.5) * pcProgress})`
      };
    },
    topFigureStyle() {
      if (this.vm.isMobile) return null;
      return {
        transform: `translateY(${-Math.min(1, this.pcProgress / 0.5) * this.breenoPhoneFirstSwipeDistance +
          this.breenoPhoneFirstSwipeDistance}px)`
      };
    }
  },
  mounted() {
    if (location.href.indexOf('localhost:800') > -1) return;

    if (!this.vm.isMobile) {
      this.getSwipeDistance();

      this.scene = new ScrollMagic.Scene({
        duration: window.innerHeight,
        triggerElement: '.high-efficiency-breeno',
        triggerHook: 0
      })
        .setPin('.high-efficiency-breeno-sticky')
        .addTo(Controller)
        .on('progress', e => {
          if (e.progress > 0.15) {
            this.pcBreenoEnter = true;
            // ie11 处理
            this.$refs.breenoIconContainer.style.animationName = 'none';
          }
          this.updateBezier('pcProgress', e.progress, 300);
        });
      window.addEventListener('resize', this.getSwipeDistance);
    }
    new ScrollMagic.Scene({
      triggerElement: '.breeno-top-figure',
      triggerHook: 0,
      offset: -100
    })
      .addTo(Controller)
      .on('enter', () => {
        this.mobileSwitch = true;
      })
      .on('leave', () => {
        this.mobileSwitch = false;
      });
  },
  destroyed() {
    window.removeEventListener('resize', this.getSwipeDistance);
  },
  methods: {
    getSwipeDistance() {
      // const bottomContainerRect = this.$refs.breenoTopContainer.getBoundingClientRect();
      // const topTextRect = this.$refs.topText.getBoundingClientRect();

      // this.breenoPhoneFirstSwipeDistance =
      //   bottomContainerRect.height + bottomContainerRect.top - topTextRect.bottom - 88;
      this.breenoPhoneFirstSwipeDistance = window.innerHeight - this.$refs.topText.clientHeight;
      if (this.scene) this.scene.duration(window.innerHeight);
    }
  }
};
</script>
